import { render, staticRenderFns } from "./step_four.vue?vue&type=template&id=7c24bf9b&scoped=true"
import script from "./step_four.vue?vue&type=script&lang=js"
export * from "./step_four.vue?vue&type=script&lang=js"
import style0 from "./step_four.vue?vue&type=style&index=0&id=7c24bf9b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c24bf9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c24bf9b')) {
      api.createRecord('7c24bf9b', component.options)
    } else {
      api.reload('7c24bf9b', component.options)
    }
    module.hot.accept("./step_four.vue?vue&type=template&id=7c24bf9b&scoped=true", function () {
      api.rerender('7c24bf9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/doubleRandom/projectExtract/step_four.vue"
export default component.exports